const API_BASE = import.meta.env.VITE_API_ENDPOINT.split('/api/')[0];

export const AuthManager = {
    init() {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const userId = urlParams.get('user_id');

        const prevUserId = localStorage.getItem('df_user_id');

        if (token && userId) {
            localStorage.setItem('df_auth_token', token);
            localStorage.setItem('df_user_id', userId);
            // Clean up URL
            window.history.replaceState({}, document.title, "/");

            // Return info about what kind of login this was
            if (!prevUserId || !prevUserId.includes('_')) {
                return 'migration'; // Anonymous to Social
            } else if (prevUserId !== userId) {
                return 'switch'; // Social A to Social B
            }
            return 'relogin';
        }
        return false;
    },

    getToken() {
        return localStorage.getItem('df_auth_token');
    },

    getUserId() {
        return localStorage.getItem('df_user_id');
    },

    isLoggedIn() {
        return !!this.getToken();
    },

    login(provider) {
        // Redirect to Backend OAuth entry point
        window.location.href = `${API_BASE}/api/auth/${provider}/login`;
    },

    async logout() {
        localStorage.removeItem('df_auth_token');
        localStorage.removeItem('df_user_id');
        const { habitStore } = await import('../store/habitStore');
        await habitStore.clearLocalData();
        window.location.replace('/');
    }
};
